module.exports = __webpack_public_path__ + "img/Butterfly_00097.86908641.png";